import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/components/ui/TextField';

const NumberClientForm = (props) => {
    const { t } = useTranslation();

    return (
        <TextField
            {...props}
            variant="number"
            errorMessage={t('form.pleaseEnterValidNumber')}
        />
    );
};

export default NumberClientForm;
